<ng-container *transloco="let t; read: 'action-plan-table'">
  <div class="action-plan-table__content">
    <h2 class="kxi-text-large">{{ t('title', { length }) }}</h2>

    @if (isLoading) {
      <div class="action-plan-table__loader">
        <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
      </div>
    }
    @if (!isLoading) {
      <div class="action-plan-table__table-wrapper">
        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          [matSortActive]="sort.active"
          [matSortDirection]="sort.direction"
          matSortDisableClear
          (matSortChange)="onSortChanged($event)"
          class="action-plan-table__table"
        >
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef [style.display]="'none'"></th>
            <td mat-cell *matCellDef="let actionPlan">
              <div class="action-plan-table__select-wrapper">
                <xi-checkbox
                  color="CX"
                  [checked]="actionPlan.isSelected"
                  [disabled]="actionPlan.isSelected"
                  (onChange)="onSelect(actionPlan.plan_id, $event.detail.target.checked)"
                >
                </xi-checkbox>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="project">
            <th mat-header-cell *matHeaderCellDef [style.display]="'none'">{{ t('project') }}</th>
            <td
              mat-cell
              *matCellDef="let actionPlan"
              [ngClass]="{ pointer: mode === 'view' }"
              (click)="onDetailsOnCell(actionPlan)"
            >
              {{ actionPlan.metadata.projectName }}
            </td>
          </ng-container>
          <ng-container matColumnDef="breakdown">
            <th mat-header-cell *matHeaderCellDef [style.display]="'none'">{{ t('breakdown') }}</th>
            <td
              mat-cell
              *matCellDef="let actionPlan"
              [ngClass]="{ pointer: mode === 'view' }"
              (click)="onDetailsOnCell(actionPlan)"
            >
              {{ actionPlan.metadata.breakdown }}
            </td>
          </ng-container>
          <ng-container matColumnDef="driver">
            <th mat-header-cell *matHeaderCellDef [style.display]="'none'">{{ t('driver') }}</th>
            <td
              mat-cell
              *matCellDef="let actionPlan"
              [ngClass]="{ pointer: mode === 'view' }"
              (click)="onDetailsOnCell(actionPlan)"
            >
              {{ actionPlan.metric_name }}
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef [style.display]="'none'"></th>
            <td
              mat-cell
              *matCellDef="let actionPlan"
              [ngClass]="{ pointer: mode === 'view' }"
              (click)="onDetailsOnCell(actionPlan)"
            >
              <app-status-label [status]="actionPlan.status" [isFixed]="true"></app-status-label>
            </td>
          </ng-container>
          <ng-container matColumnDef="completed">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="action-plan-table__completed-header"
            >
              <div>{{ t('completed') }}</div>
            </th>
            <td
              mat-cell
              *matCellDef="let actionPlan"
              class="action-plan-table__text-center-column"
              [ngClass]="{ pointer: mode === 'view' }"
              (click)="onDetailsOnCell(actionPlan)"
            >
              {{
                t('count', {
                  count: actionPlan.completed_child_count,
                  total: actionPlan.total_child_count,
                })
              }}
            </td>
          </ng-container>
          <ng-container matColumnDef="past_due">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="action-plan-table__past-due-header"
            >
              <div>{{ t('past-due') }}</div>
            </th>
            <td
              mat-cell
              *matCellDef="let actionPlan"
              class="action-plan-table__text-center-column"
              [ngClass]="{ pointer: mode === 'view' }"
              (click)="onDetailsOnCell(actionPlan)"
            >
              {{
                t('count', {
                  count: actionPlan.past_due_child_count,
                  total: actionPlan.total_child_count,
                })
              }}
            </td>
          </ng-container>
          <ng-container matColumnDef="due_date">
            <th mat-header-cell *matHeaderCellDef [style.display]="'none'">{{ t('due-date') }}</th>
            <td
              mat-cell
              *matCellDef="let actionPlan"
              [ngClass]="{ pointer: mode === 'view', 'action-plan-expired': actionPlan.isExpired }"
              (click)="onDetailsOnCell(actionPlan)"
              [matTooltip]="actionPlan.expiredTooltip"
            >
              {{ actionPlan.due_date | date: 'dd-MM-yyyy' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef [style.display]="'none'"></th>
            <td mat-cell *matCellDef="let actionPlan">
              <div [matMenuTriggerFor]="actionsMenuTrigger">
                <xi-icon-button
                  color="CX"
                  buttonSize="small"
                  icon="kabob"
                  (onClick)="onActionsMenuToggle(actionPlan)"
                ></xi-icon-button>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="select_def">
            <th mat-header-cell *matHeaderCellDef rowspan="2">
              <div></div>
            </th>
          </ng-container>
          <ng-container matColumnDef="project_def">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              rowspan="2"
              class="action-plan-table__project-header"
            >
              {{ t('project') }}
            </th>
          </ng-container>
          <ng-container matColumnDef="breakdown_def">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              rowspan="2"
              class="action-plan-table__breakdown-header"
            >
              {{ t('breakdown') }}
            </th>
          </ng-container>
          <ng-container matColumnDef="driver_def">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              rowspan="2"
              class="action-plan-table__driver-header"
            >
              {{ t('driver') }}
            </th>
          </ng-container>
          <ng-container matColumnDef="status_def">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              rowspan="2"
              class="action-plan-table__status-header"
            >
              {{ t('status') }}
            </th>
          </ng-container>
          <ng-container matColumnDef="action_items">
            <th
              mat-header-cell
              *matHeaderCellDef
              colspan="2"
              class="action-plan-table__action-items-header"
            >
              {{ t('action-items') }}
            </th>
          </ng-container>
          <ng-container matColumnDef="due_date_def">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              rowspan="2"
              class="action-plan-table__due-date-header"
            >
              {{ t('due-date') }}
            </th>
          </ng-container>
          <ng-container matColumnDef="actions_def">
            <th
              mat-header-cell
              *matHeaderCellDef
              rowspan="2"
              class="action-plan-table__actions-header"
            >
              <div></div>
            </th>
          </ng-container>
          <tr
            mat-header-row
            *matHeaderRowDef="defColumns; sticky: true"
            class="action-plan-table__table-header-row"
          ></tr>
          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
            class="action-plan-table__table-header-row"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="action-plan-table__table-data-row"
            [ngClass]="{ 'action-plan-table__selected-row': row.isSelected }"
          ></tr>
        </table>
      </div>
    }
    @if (length) {
      <app-paginator
        [length]="length"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (pageChanged)="onPageChanged($event)"
      >
      </app-paginator>
    }
  </div>

  <mat-menu #actionsMenuTrigger>
    <button mat-menu-item (click)="onDetails()">{{ t('details') }}</button>

    <button mat-menu-item [disabled]="isReadOnly" (click)="onEdit()">{{ t('edit') }}</button>

    <button mat-menu-item [disabled]="isReadOnly" (click)="onDelete()">{{ t('delete') }}</button>
  </mat-menu>
</ng-container>
